import { render, staticRenderFns } from "./ProductSalesPageSolution.vue?vue&type=template&id=4b95bee5&scoped=true&"
import script from "./ProductSalesPageSolution.vue?vue&type=script&lang=ts&"
export * from "./ProductSalesPageSolution.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b95bee5",
  null
  
)

export default component.exports